import request from '@/libs/request';
import config from '@/config';
import RSA from '@/libs/rsa';
const baseUrl = config.api_base;

/**
 * 新增用户
 */
export const UserAdd = data => {
  return request('POST', `${baseUrl}/api/auth/sys/user/save`, data);
};

/**
 * 删除用户
 */
export const UserDelete = data => {
  return request('POST', `${baseUrl}/api/auth/sys/user/del`, data);
};

/**
 * 获取用户详情
 */
export const UserDetail = params => {
  return request('GET', `${baseUrl}/api/auth/sys/user/detail`, params);
};

/**
 * 禁用/解除禁用用户
 */
export const UserDisable = data => {
  return request('POST', `${baseUrl}/api/auth/sys/user/disable`, data);
};

/**
 * 编辑用户
 */
export const UserEdit = data => {
  return request('POST', `${baseUrl}/api/auth/sys/user/edit`, data);
};

/**
 * 用户列表
 */
export const UserList = params => {
  return request('GET', `${baseUrl}/api/auth/sys/user/page`, params);
};

/**
 * 配置权限{apiNoUse}
 */
export const UserAuth = data => {
  return request('GET', `${baseUrl}/api/auth/sys/user/auth`, data);
};

/**
 * 配置权限提交
 */
export const UserAuthSave = data => {
  return request('POST', `${baseUrl}/api/auth/sys/user/auth/submit`, data);
};

/**
 * 站点列表
 */
export const UserAuthSites = params => {
  return request('GET', `${baseUrl}/api/auth/sys/user/auth/stations`, params);
};

/**
 * 修改用户密码
 */
export const UserChangePassword = data => {
  // 密码加密
  data.password = RSA.encrypt(data.password);

  return request('POST', `${baseUrl}/api/auth/sys/user/edit/pwd`, data);
};

/**
 *  获取角色列表，用于下拉框显示
 */
export const RoleListSelect = params => {
  return request('GET', `${baseUrl}/api/auth/sys/permission/role/selectall`, params);
};
